import { useRef, useState } from "react";
import Navigation from "../navigation/navigation";
import ActEdLogo from "../../assets/ActEd-Logo.webp";
import Hamburger from "../hamburger/hamburger";
import "./header.css";

export default function Header() {
  const [open, setOpen] = useState(false);
  const onHamburgerClick = () => {
    setOpen(!open);
  };

  const nav = useRef<any>(null);

  const closeNav = (e: any) => {
    if (open && !nav.current?.contains(e.target)) {
      setOpen(false);
    }
  };
  document.addEventListener("mousedown", closeNav);

  return (
    <header className="ae-header-container" ref={nav} data-testid="header">
      <a href="/" className="ae-header-logo-link" aria-label="ActEd. home">
        <img src={ActEdLogo} alt="" className="ae-header-logo" />
      </a>
      <Hamburger onClickHandler={onHamburgerClick} open={open} />
      <Navigation open={open} />
    </header>
  );
}
